<template>
    <div>
        <p>{{ msg }}</p>
    </div>
</template>
<script>
export default {
    name:'SupervisorCatering',
    data(){
        return {
            msg:'Información del Sipervisor del Casíno'
        }
    }    
}
</script>


// WEBPACK FOOTER //
// src/components/catering/SupervisorCatering.vue